Instructions on how this candidate should be distributed.

Currently, one product code is defined for uploaded candidates:

- `ProactiveSourcing` indicates that the candidate may be viewed in SEEK Talent Search.
